import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

export const fireAppsMoreActionsButtonClicked =
	(createAnalyticsEvent: CreateUIAnalyticsEvent) => () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'appsNavigationMenuItem',
				source: 'globalNavigation',
				attributes: {
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					navVersion: '4',
					componentType: 'fixedItemButton',
					itemId: 'meatballDropdown',
				},
			},
		}).fire();
	};

export const fireAppsMoreActionsDropdownItemClicked =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, itemId: string) => () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'dropdownItem',
				actionSubjectId: 'appsNavigationMenuItem',
				source: 'globalNavigation',
				attributes: {
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					navVersion: '4',
					componentType: 'fixedItemAction',
					parentItemId: 'apps',
					itemId,
				},
			},
		}).fire();
	};

export const fireAppsNavigationItemClicked =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, itemId: string | null) => () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'appsNavigationMenuItem',
				source: 'globalNavigation',
				attributes: {
					navigationLayer: 'global',
					navigationContainer: 'sidebar',
					navVersion: '4',
					componentType: 'customItem',
					itemType: 'app',
					itemId,
					section: 'yourApps',
				},
			},
		}).fire();
	};
